import { toState } from '../base/redux';
import type { Dispatch } from 'redux';
import { setTileViewDimensions as _setTileViewDimensions } from './actions.web';

export * from './actions.web';

export function setTileViewDimensions(dimensions: Object) {
    return (dispatch: Dispatch<any>, getState: Function) => {
        const state = getState();
        // const { isOpen: isChatOpen } = state['features/chat'];
        // const { isOpen: isParticipantsPaneOpen } = state['features/participants-pane'];
        // if(!isChatOpen && !isParticipantsPaneOpen) {
        //     state['features/base/responsive-ui'].clientHeight = state['features/base/responsive-ui'].clientHeight;
        // }
        return _setTileViewDimensions(dimensions)(dispatch, getState);
    }
}